import request from '../utils/request'
import axios from 'axios'

export const login = (data) => request.post('/login', data)
export const getUserInfo = (userId) => request.get('/user/info', { params: { userId } })

export const getUserList = (params = {}) => request.get('/user/list', { params })
export const getUserById = (id) => request.get('/user/' + id)
export const saveUser = (data) => request.post('/user/save', data)
export const deleteUser = (id) => request.delete('/user/' + id)

export const getRoleList = () => request.get('/role/list')
export const getDeptTree = () => request.get('/dept/tree')
export const getRoleById = (id) => request.get('/role/' + id)
export const saveRole = (data) => request.post('/role/save', data)
export const deleteRole = (id) => request.delete('/role/' + id)
export const getRoleMenuIds = (roleId) => request.get('/role/menu/' + roleId)
export const assignRoleMenus = (data) => request.post('/role/menu/assign', data)

export const getMenuList = () => request.get('/menu/list')
export const getMenuById = (id) => request.get('/menu/' + id)
export const getMenuByRoleId = (roleId) => request.get('/menu/role/' + roleId)
export const saveMenu = (data) => request.post('/menu/save', data)
export const deleteMenu = (id) => request.delete('/menu/' + id)

export const getWorkOrderList = () => request.get('/workorder/list')
export const getWorkOrderListPage = (params = {}) => request.get('/workorder/list-page', { params })
export const getWorkOrderById = (id) => request.get('/workorder/' + id)
export const saveWorkOrder = (data) => request.post('/workorder/save', data)
export const assignWorkOrder = (id, data) => request.post('/workorder/' + id + '/assign', data)
export const deleteWorkOrder = (id) => request.delete('/workorder/' + id)

export const getPatrolRecordList = () => request.get('/patrol/record/list')
export const getPatrolRecordListPage = (params = {}) => request.get('/patrol/record/list-page', { params })
export const getPatrolRecordById = (id) => request.get('/patrol/record/' + id)
export const savePatrolRecord = (data) => request.post('/patrol/record/save', data)
export const deletePatrolRecord = (id) => request.delete('/patrol/record/' + id)

export const getPatrolPlanList = () => request.get('/patrol/plan/list')
export const getPatrolPlanById = (id) => request.get('/patrol/plan/' + id)
export const savePatrolPlan = (data) => request.post('/patrol/plan/save', data)
export const deletePatrolPlan = (id) => request.delete('/patrol/plan/' + id)

export const getContractList = (params = {}) => request.get('/contract/list', { params })
export const getContractListPage = (params = {}) => request.get('/contract/list-page', { params })
export const getContractById = (id) => request.get('/contract/' + id)
export const saveContract = (data) => request.post('/contract/save', data)
export const deleteContract = (id) => request.delete('/contract/' + id)
export const importContracts = (list) => request.post('/contract/import', list)

export const getGrainStoreList = (params = {}) => request.get('/grainstore/list', { params })
export const getMonitorStores = () => request.get('/monitor/stores')
export const getGrainStoreById = (id) => request.get('/grainstore/' + id)
export const saveGrainStore = (data) => request.post('/grainstore/save', data)
export const deleteGrainStore = (id) => request.delete('/grainstore/' + id)

// 粮库 Excel 导入导出（绕过 axios 拦截器，因为返回的不是 JSON）
export const exportGrainStores = (params = {}) => {
  return axios.get('/api/grainstore/export', { params, responseType: 'blob' })
}
export const downloadGrainStoreTemplate = () => {
  return axios.get('/api/grainstore/template', { responseType: 'blob' })
}
export const importGrainStores = (file) => {
  const fd = new FormData()
  fd.append('file', file)
  return request.post('/grainstore/import', fd, {
    headers: { 'Content-Type': 'multipart/form-data' }
  })
}

export const getWarehouseList = () => request.get('/warehouse/list')
export const getWarehouseById = (id) => request.get('/warehouse/' + id)
export const getWarehouseByGrainStoreId = (grainStoreId) => request.get('/warehouse/grainstore/' + grainStoreId)
export const saveWarehouse = (data) => request.post('/warehouse/save', data)
export const deleteWarehouse = (id) => request.delete('/warehouse/' + id)

export const getMonitorList = () => request.get('/monitor/list')
export const getMonitorById = (id) => request.get('/monitor/' + id)
export const getMonitorByGrainStoreId = (grainStoreId) => request.get('/monitor/grainstore/' + grainStoreId)
export const saveMonitor = (data) => request.post('/monitor/save', data)
export const deleteMonitor = (id) => request.delete('/monitor/' + id)

export const uploadFile = (data, type = 'plan') => {
  // System.vue 直接传 FormData（已指定 type 参数），旧调用传 File 对象
  if (data instanceof FormData) {
    return request.post('/upload?type=' + type, data, {
      headers: { 'Content-Type': 'multipart/form-data' }
    })
  }
  const formData = new FormData()
  formData.append('file', data)
  formData.append('type', type)
  return request.post('/upload', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  })
}

export const getAlarmList = (params = {}) => request.get('/alarm/list', { params })
export const getAlarmListPage = (params = {}) => request.get('/alarm/list-page', { params })
export const getAlarmById = (id) => request.get('/alarm/' + id)
export const handleAlarm = (data) => request.post('/alarm/handle', data)
export const deleteAlarm = (id) => request.delete('/alarm/' + id)

export const getConfigList = () => request.get('/config/list')
export const getConfigMap = () => request.get('/config/map')
export const saveConfig = (data) => request.post('/config/save', data)
export const saveConfigBatch = (data) => request.post('/config/batch', data)
export const deleteConfig = (id) => request.delete('/config/' + id)

export const getPushConfigList = () => request.get('/push/config/list')
export const savePushConfig = (data) => request.post('/push/config/save', data)
export const deletePushConfig = (id) => request.delete('/push/config/' + id)

export const getPushLogList = (params = {}) => request.get('/push/log/list', { params })
export const getPushLogDetail = (id) => request.get('/push/log/' + id)

export const getDashboardOverview = () => request.get('/dashboard/overview')
export const getDashboardStats = (params = {}) => request.get('/dashboard/stats', { params })